import {createAction} from 'redux-act'

export const updateAuthUser = createAction(
  'Update user state'
)
